module.exports = __webpack_public_path__ + "img/category-unknown-reverse.06f61fc7.svg";